export default class PasswordReset extends HTMLAnchorElement{
    constructor() {
        super();
    }

    connectedCallback() {
        this.forcePwdReset();
    }

    forcePwdReset() {
        this.addEventListener('click',(e) => {
            e.preventDefault();
            e.stopImmediatePropagation();

            let href = this.href;

            swal({
                animation: false,
                customClass: 'animated fadeIn',
                title: 'Attention !',
                text: 'Êtes-vous sûr de vouloir réinitialiser le mot de passe de l\'utilisateur ?',
                allowOutsideClick: true,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#D2282D',
                cancelButtonText: 'Annuler',
                confirmButtonText: 'Oui !',
                showLoaderOnConfirm: true,
                preConfirm: function () {
                    return new Promise(function (resolve) {
                        $.ajax({
                            method: 'PUT',
                            url: href,
                            statusCode: {
                                404: function (xhr) {
                                    CoreNotification.error('Cette ligne n\'existe plus.');
                                },
                                500: function (xhr) {
                                    CoreNotification.error('Une erreur est survenue.');
                                }
                            },
                            success: function (data) {
                                CoreNotification.success('Envoi du nouveau mot de passe effectué avec succès');
                            },
                            complete: function (data) {
                                window.AppDatatable.table.ajax.reload();

                                resolve();
                            }
                        });
                    });
                }
            }).then(function (result) {
                swal.close();
            });
        });
    }
}